import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=22e4764c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e4764c')) {
      api.createRecord('22e4764c', component.options)
    } else {
      api.reload('22e4764c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=22e4764c&", function () {
      api.rerender('22e4764c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D7JXo05vHXns/JS/comp/ErrorMessage.vue"
export default component.exports